<template>
  <div class="chart-box" :style="this.preData.show ? `zoom: ${size}; width: 355px; height: 178px` : ` width: 231px; height: 190px`">
    <chart-block ref="chart2" :style="this.preData.show ? `width: 355px; height: 178px` : ` width: 231px; height: 190px`" class="chart2"></chart-block>
  </div>
</template>

<script type="text/javascript">
export default {
  props: ["preData"],
  data() {
    return {
      size: 0,
    };
  },
  computed: {
    chartPieOption() {
      return {
        title: {
          text: this.preData.title || "",
          textStyle: {
            color: this.preData.show ? "#000000" : "#3096FB",
            fontWeight: "bold",
            fontSize: 18,
            fontFamily: "Microsoft YaHei",
          },
        },
        legend: {
          show: this.preData.show,
          right: "0%",
          bottom: 25,
          orient: "vertical",
          textStyle: {
            color: "#000000",
            fontWeight: "bold",
            fontSize: 15,
            fontFamily: "Microsoft YaHei",
          },
          formatter: (name) => {
            let index = this.preData.typeList.map((item) => item.name).indexOf(name);
            if (index != -1) {
              return name + "   " + this.preData.typeList[index].value;
            } else {
              return "";
            }
          },
        },
        series: [
          {
            type: "pie",
            color: this.preData.show ? ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"] : ["#FA7369", "#F0F0F0"],
            left: 0,
            width: 150,
            height: 150,
            radius: ["60%", "100%"],
            center: [95, 103],
            data: this.preData.typeList,
            label: {
              normal: {
                show: true,
                position: "center",
                color: "#4c4a4a",
                formatter: this.preData.countLength,
                rich: {
                  totalText: {
                    fontSize: 15,
                    fontFamily: "Microsoft YaHei",
                    fontWeight: "bold",
                    color: "#1F96FA",
                  },
                },
              },
              emphasis: {
                show: true,
              },
            },
          },
        ],
      };
    },
  },
  components: {},
  watch: {
    chartPieOption: {
      handler(newValue) {
        if (this.chartPieOption.series[0].data.every((item) => item.value === 0)) {
          this.chartPieOption.series[0].color = ["#cccccc"]; // 设置为灰色
        }
        // this.chartPieOption.series[0].color = "#f5f5f5";
        this.size = document.documentElement.clientWidth / 1920;
        this.$refs.chart2.setOption(this.chartPieOption, true);
      },
    },
  },
  mounted() {
    // console.log(this, this.areAllValuesZero);
    if (this.chartPieOption.series[0].data.every((item) => item.value === 0)) {
      this.chartPieOption.series[0].color = ["#cccccc"]; // 设置为灰色
    }
    this.$refs.chart2.setOption(this.chartPieOption, true);
    window.onresize = function () {
      this.$refs.chart2.resize();
    };
  },
  beforeDestroy() {},
  methods: {},
};
</script>

<style scoped>
/* .chart-box {
  width: 355px;
  height: 188px;
}
.chart2 {
  width: 355px;
  height: 188px;
} */
</style>
